import { useState, useContext, useEffect } from "react"
import { makeStyles } from "@material-ui/core/styles"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import IconButton from "@material-ui/core/IconButton"
import DeleteIcon from "@material-ui/icons/Delete"
import EditIcon from "@material-ui/icons/Edit"
import DrawerSheets from "../DrawerSheets"
import Button from "@material-ui/core/Button"
import AddIcon from "@material-ui/icons/Add"
import GetAppIcon from "@material-ui/icons/GetApp"
import { CSVLink } from "react-csv"
import { deleteBedGesCaec } from "../../services/sheets"
import DashboardUnit from "../../contexts/dashboardUnitContext"

const headCells = [
  { id: "patientRut", numeric: false, disablePadding: true, label: "RUT" },
  { id: "bedCode", numeric: false, disablePadding: false, label: "CÓDIGO DE CAMA" },
  { id: "state", numeric: false, disablePadding: true, label: "DIAGNOSTICO" },
  { id: "action", numeric: false, disablePadding: true, label: "ACCION" },
]

const EnhancedTableHead = () => {
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell key={headCell.id} align="center" padding="normal">
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: "80rem",
    margin: "auto",
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  statusService: {
    width: "6rem",
    height: "2.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2rem",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  title: {
    fontSize: "2.3rem",
    color: "#566573",
    margin: "2rem 0 3rem 0",
  },
  contentAdd: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      justifyContent: "flex-start",
    },
  },
  iconAdd: {
    backgroundColor: "#009DB1",
    marginRight: "2rem",
    marginBottom: "0.5rem",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#009DB1",
    },
  },
  link: {
    textDecoration: "none",
  },
}))

const TableGesCaec = ({ detailsGesCaec, reloadData, setDetailsGesCaec }) => {
  const classes = useStyles()
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [registerDate, setRegisterData] = useState()
  const [openDrawer, setOpenDrawer] = useState()

  const [unit, setUnit] = useState(0)
  const { detailsUnit } = useContext(DashboardUnit)

  useEffect(() => {
    const unitId = detailsUnit?.unit[0]?.id
    setUnit(unitId)
  }, [detailsUnit])

  useEffect(() => {
    if (detailsUnit) {
      if (unit !== detailsUnit?.unit[0]?.id) reloadData()
    }
    return () => setDetailsGesCaec([])
  }, [detailsUnit, unit])

  const headersCsv = [
    { key: "admissionCode", label: "ID Ingreso" },
    { key: "patientRut", label: "RUT" },
    { key: "bedCode", label: "Código de Cama" },
    { key: "diagnostic", label: "Diagnóstico" },
  ]

  const onOpenDrawer = (code) => {
    setOpenDrawer(true)
    setRegisterData(code)
  }

  const onCloseDrawer = () => {
    setOpenDrawer(false)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleDeleteBedGesCaec = async (code, bedCode) => {
    try {
      const resp = await deleteBedGesCaec(code, bedCode)
      reloadData()
    } catch (error) {
      console.log(error)
    }
  }

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, detailsGesCaec.length - page * rowsPerPage)

  return (
    <div className={classes.root}>
      <div>
        <div className={classes.contentAdd}>
          <CSVLink
            data={detailsGesCaec}
            filename={"planillaGES-CAEC.csv"}
            headers={headersCsv}
            className={classes.link}
          >
            <Button variant="contained" className={classes.iconAdd} startIcon={<GetAppIcon />}>
              Exportar a CSV
            </Button>
          </CSVLink>
          <Button
            variant="contained"
            className={classes.iconAdd}
            startIcon={<AddIcon />}
            onClick={() => onOpenDrawer()}
          >
            Agregar registro
          </Button>
        </div>
        <TableContainer>
          <Table className={classes.table} aria-labelledby="tableTitle" size="medium" aria-label="enhanced table">
            <EnhancedTableHead classes={classes} rowCount={detailsGesCaec.length} />
            <TableBody>
              {detailsGesCaec.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                const labelId = `enhanced-table-checkbox-${index}`

                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={labelId}>
                    <TableCell component="th" id={labelId} scope="row" align="center">
                      {!row.patientRut ? "-" : row.patientRut}
                    </TableCell>
                    <TableCell align="center">{!row.bedCode ? "-" : row.bedCode}</TableCell>
                    <TableCell align="center">{!row.diagnostic ? "-" : row.diagnostic}</TableCell>
                    <TableCell align="center">
                      <IconButton
                        aria-label="delete"
                        onClick={() => handleDeleteBedGesCaec(row.admissionCode, row.bedCode)}
                      >
                        <DeleteIcon />
                      </IconButton>
                      <IconButton
                        aria-label="edit"
                        onClick={() =>
                          onOpenDrawer({
                            admissionCode: row.admissionCode,
                            diagnostic: row.diagnostic,
                            patientRut: row.patientRut,
                            bedCode: row.bedCode,
                          })
                        }
                      >
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                )
              })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={detailsGesCaec.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </div>
      <DrawerSheets
        open={openDrawer}
        registerDate={registerDate}
        mode="gescaec"
        onClose={() => onCloseDrawer()}
        reloadData={reloadData}
      />
    </div>
  )
}

export default TableGesCaec
